var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{attrs:{"title":"Total Building Square Feet"}},[_c('div',{staticClass:"flex flex-1 justify-between -mt-4"},[_c('div',{staticClass:"w-56"},[_c('input-number',{attrs:{"name":"square_feet","read_only":_vm.read_only},model:{value:(_vm.square_feet),callback:function ($$v) {_vm.square_feet=$$v},expression:"square_feet"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }